import styled from "styled-components"

import { Color, LineHeight, SpacingSize } from "~/consts/style-mixins"

import AutoLink from "../atoms/AutoLink"

interface Props {
  items: {
    name: string
    content: string | null
  }[]
}

const Table = ({ items }: Props) => {
  return (
    <>
      {items.map((item, index) => {
        return (
          item.content && (
            <StyledRow key={index}>
              <StyledItemName>{item.name}</StyledItemName>
              <StyledItemContent>
                <AutoLink>{item.content}</AutoLink>
              </StyledItemContent>
            </StyledRow>
          )
        )
      })}
    </>
  )
}

const StyledRow = styled.div`
  padding: 12px 0;
  display: flex;
  font-size: 14px;
  line-height: ${LineHeight.S}%;
  text-align: left;
  border-top: 1px solid ${Color.BorderGray};
  &:last-child {
    border-bottom: 1px solid ${Color.BorderGray};
  }
`

const StyledItemName = styled.div`
  width: 80px;
  line-height: ${LineHeight.S}%;
  font-weight: bold;
  color: ${Color.LightGray};
  margin-right: ${SpacingSize.XS}px;
`

const StyledItemContent = styled.div`
  white-space: pre-line;
  width: calc(100% - 80px);
`

export default Table
